import {Routes} from '@angular/router';

import {
    aideRoute,
    archiveRoute,
    auditsRoute,
    configurationRoute,
    docsRoute,
    healthRoute,
    logsRoute,
    metricsRoute,
    userDialogRoute,
    userEchangeDialogRoute,
    userEchangeRoute,
    userMgmtRoute,
} from './';

import {UserRouteAccessService} from '../shared';

let ADMIN_ROUTES = [
    auditsRoute,
    configurationRoute,
    archiveRoute,
    docsRoute,
    healthRoute,
    logsRoute,
        ...userMgmtRoute,
    metricsRoute
];


export const adminState: Routes = [
    {
        path: '',
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM']
        },
        canActivate: [UserRouteAccessService],
        children: ADMIN_ROUTES
    },
    {
        path: 'user_echange',
        pathMatch: 'prefix',
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM', 'ROLE_GEST']
        },
        canActivate: [UserRouteAccessService],
        children: ADMIN_ROUTES
    },
    ...userDialogRoute,
    ...userEchangeDialogRoute,
    ...userEchangeRoute,
    ...aideRoute,

];



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/admin.route.ts